import DomainRecords from '@/components/MyDomains/Settings/DomainRecords'
import DomainOverview from '@/components/MyDomains/Overview'
import DomainContacts from '@/components/MyDomains/Contacts'
import DomainAdvancedSettings from '@/components/MyDomains/AdvancedSettings'
import Nameservers from '@/components/MyDomains/Settings/Nameservers'
import DNSSecurity from '@/components/MyDomains/Settings/DNSSecurity'
import DomainList from '@/components/MyDomains/List'
import SearchHandler from '@/components/DomainRegistration/SearchHandler'
import DomainTransfer from '@/components/DomainRegistration/DomainTransfer'

const advancedSettingsRoutes = [
  {
    path: 'dns-records',
    name: 'DNSRecords',
    component: DomainRecords,
    meta: {
      title: 'My Services - DNS Management'
    }
  },
  {
    path: 'nameservers',
    name: 'Nameservers',
    component: Nameservers,
    meta: {
      title: 'My Services - DNS Management'
    }
  },
  {
    path: 'dns-security',
    name: 'DNSSecurity',
    component: DNSSecurity,
    meta: {
      title: 'My Services - DNS Management'
    }
  }
]

export const domainRoutes = [
  {
    path: 'list',
    name: 'DomainList',
    component: DomainList,
    meta: {
      title: 'My Services - DNS Management'
    }
  },
  {
    path: 'contacts',
    name: 'DomainContacts',
    component: DomainContacts,
    meta: {
      title: 'My Services - DNS Management'
    }
  },
  {
    path: 'advanced-settings',
    name: 'DomainAdvancedSettings',
    component: DomainAdvancedSettings,
    redirect: { name: 'DNSRecords' },
    children: advancedSettingsRoutes
  },
  {
    path: 'overview',
    name: 'DomainOverview',
    component: DomainOverview,
    meta: {
      title: 'My Services - DNS Management'
    }
  }
]

export const searchRegistrationRoutes = [
  {
    path: 'search',
    name: 'RegistrationSearch',
    component: SearchHandler,
    meta: {
      title: 'My Services - DNS Management'
    }
  },
  {
    path: 'transfer',
    name: 'DomainTransfer',
    component: DomainTransfer,
    meta: {
      title: 'My Services - Domain Transfer'
    }
  }
]
